// extracted by mini-css-extract-plugin
export var breadcrumbList = "blog-breadcrumbs-module--breadcrumbList--8d3c6";
export var icon = "blog-breadcrumbs-module--icon--68f4a";
export var title = "blog-breadcrumbs-module--title--99134";
export var wrapper = "blog-breadcrumbs-module--wrapper--bbaa9";